import StoredLayout from '../../layouts/StoredLayout'
import Users from './Users'
export default StoredLayout(Users)
